import { render, staticRenderFns } from "./BttPopup.vue?vue&type=template&id=10f22408&scoped=true&lang=pug&"
import script from "./BttPopup.vue?vue&type=script&lang=ts&"
export * from "./BttPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BttPopup.vue?vue&type=style&index=0&id=10f22408&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f22408",
  null
  
)

export default component.exports